import React, { useEffect, useState } from 'react';
import { getFeedsData } from '../../../datafetchers/HomePage';
//import { getValues } from "../../../Utils/firebaseLiveData";
import ArticleContent from './ArticleContent';
import RelatedQuestion from './RelatedQuestion';
import { ShowLoader } from '../../Common/LoaderComponent';
import {
  RelatedCardSectionGrid,
  RelatedTopicContainer,
  TopicType,
} from './styled';
import LoadMore from './LoadMore';
import useSWR from 'swr';
import { getFirebaseLiveData } from '../../../Utils/firebaseLiveData';
import {
  fireClickedCardEvent,
  fireClickedTabEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function TabsCardData(props) {
  const { generalTabsName, tagId, updatedGeneralTabData, setShowFullLoader } =
    props;
  const [hideLoadMore, setHideLoadMore] = useState(false);
  const generalItemsInitialData = updatedGeneralTabData;
  const generalItemsInitialKey = generalTabsName?.[0]?.key;
  const initialPageCount = 1;
  const initialData = {
    items: generalItemsInitialData?.items,
    key: generalItemsInitialKey,
  };

  const { data, error, mutate } = useSWR(
    `topic_${tagId}_${initialData?.key}`,
    () => {
      console.log('');
    },
    {
      fallbackData: initialData,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
    },
  );
  const [showLoader, setShowLoader] = useState();

  const viewsValueData = async (id) => {
    const { getValues } = getFirebaseLiveData();
    const updatedData = await getValues('Views/OwnArticle/', id);
    const views = updatedData?.views;
    return views;
  };
  const [newData, setNewData] = useState(data);

  useEffect(() => {
    setNewData(data);
    if (
      updatedGeneralTabData?.items?.length <
      updatedGeneralTabData?._meta?.perPage
    ) {
      setHideLoadMore(true);
    }
  }, []);

  const getDataOnTabClick = (key, name) => {
    fireClickedTabEvent(name);
    setShowLoader(true);
    getFeedsData({
      tag: tagId,
      page: initialPageCount,
      type: key == 'questions' ? 'post' : key,
      shortenFeedResponse: true,
    }).then((response) => {
      const data = {
        items: response?.data?.posts?.items,
        key: key,
      };
      mutate(data, false);
      setNewData(data);
      setShowLoader(false);
      if (
        response?.data?.posts?.items?.length <
        response?.data?.posts?._meta?.perPage
      ) {
        setHideLoadMore(true);
      }
    });
  };

  const clickedCardEvent = (cardName, cardId) => {
    generalTabsName?.map((element, index) => {
      if (newData?.key == element?.key) {
        let fullCardName = `${element?.tabName}_${cardName}`;
        let slicedName = fullCardName.slice(0, 98);
        fireClickedCardEvent('featured_tabs', slicedName, 'topic', cardId);
      }
    });
  };
  // check
  useEffect(() => {
    if (data?.items?.length) {
      let cardIds = '';
      data?.items?.map((element, index) => {
        let id = element?.content?.id;
        index == 0
          ? (cardIds = JSON.stringify(id))
          : (cardIds = cardIds + ',' + id);
      });
      cardIds = cardIds.slice(0.98);
      fireServedSectionEvent(newData?.key, cardIds, 'topic');
    }
  }, [newData?.key]);

  return (
    <>
      <RelatedTopicContainer>
        <TopicType>
          {generalTabsName?.map((element, index) => {
            if (element?.key != 'topic_products') {
              return (
                <li
                  className={newData?.key == element?.key ? 'active' : null}
                  onClick={() => {
                    getDataOnTabClick(element?.key, element?.tabName);
                  }}
                  key={`tabName_${index}`}
                  id={`tabName_${index}`}
                >
                  {element?.tabName}
                </li>
              );
            }
          })}
        </TopicType>
        {showLoader && <ShowLoader />}
        <RelatedCardSectionGrid>
          {newData?.items?.map((element) => {
            switch (element?.content_type) {
              case '4':
                return (
                  <RelatedQuestion
                    content={element?.content}
                    clickedCardEvent={clickedCardEvent}
                  />
                );
              default:
                return (
                  <ArticleContent
                    content={element?.content}
                    viewsData={viewsValueData}
                    clickedCardEvent={clickedCardEvent}
                    outerContent={element}
                  />
                );
            }
          })}
        </RelatedCardSectionGrid>
      </RelatedTopicContainer>
      {!hideLoadMore ? (
        <LoadMore
          mutate={mutate}
          tabData={generalTabsName}
          selectedTab={newData}
          setShowLoader={setShowFullLoader}
          tagId={tagId}
          setNewData={setNewData}
          setHideLoadMore={setHideLoadMore}
          initialPageCount={initialPageCount}
        />
      ) : null}
    </>
  );
}
